import { ErrorCodeToStatusMapping } from '@linqpal/models/src/dictionaries'
import { InsufficientFundsError } from '@linqpal/models/src/types/exceptions'

export const getStatusMessage = (
  result: string,
  err: any,
  t: (key: string) => string,
) => {
  if (
    result === InsufficientFundsError.name ||
    err.result === InsufficientFundsError.name
  ) {
    return t('errors:insufficient-funds')
  }
  if (result === 'LogicalError') {
    return t('errors:error-occurred')
  }
  return t('errors:system-failure')
}

export const getErrorMessage = (err: any) => {
  return (
    err.response?.data?.message ||
    err.data?.message ||
    err.message ||
    err.toString()
  )
}

export const handleError = (
  errorCode: string | null,
  err: any,
  t: (key: string) => string,
) => {
  if (errorCode) {
    const status = ErrorCodeToStatusMapping[errorCode].replace(
      /([a-z])([A-Z])/g,
      '$1 $2',
    )
    const message = errorCode
    return { status, message }
  } else {
    console.error(err)
    const result = err.response?.data?.result || t('errors:system-failure')

    const status = getStatusMessage(result, err, t)
    const message = getErrorMessage(err)

    return { status, message }
  }
}
